// General Actions - Switch conversation tabs
export const CMD_SWITCH_TAB = 'CMD_SWITCH_TAB';

// General Actions - Switch conversation status
export const CMD_SWITCH_STATUS = 'CMD_SWITCH_STATUS';

// Conversation Actions
export const CMD_MUTE_CONVERSATION = 'CMD_MUTE_CONVERSATION';
export const CMD_UNMUTE_CONVERSATION = 'CMD_UNMUTE_CONVERSATION';
export const CMD_SEND_TRANSCRIPT = 'CMD_SEND_TRANSCRIPT';
export const CMD_TOGGLE_CONTACT_SIDEBAR = 'CMD_TOGGLE_CONTACT_SIDEBAR';

// Status Commands
export const CMD_REOPEN_CONVERSATION = 'CMD_REOPEN_CONVERSATION';
export const CMD_RESOLVE_CONVERSATION = 'CMD_RESOLVE_CONVERSATION';
export const CMD_SNOOZE_CONVERSATION = 'CMD_SNOOZE_CONVERSATION';
export const CMD_AI_ASSIST = 'CMD_AI_ASSIST';
